<template>
  <div class="list">
    <div class="header">
      <div class="l">
        <div class="label">
          课程状态
        </div>
        <el-select
          v-model="searchForm.valid"
          placeholder="请选择课程状态"
          filterable
          clearable
          @change="getList()"
        >
          <el-option
            v-for="item in courseStatusList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <div class="label">
          课程分类
        </div>
        <el-select
          v-model="searchForm.courseCategoryId"
          placeholder="请选择课程分类"
          filterable
          clearable
          @change="getList()"
        >
          <el-option
            v-for="item in courseCategoryList"
            :key="item.value"
            :label="item.value"
            :value="item.id"
          />
        </el-select>
        <div class="label">
          课程方式
        </div>
        <el-select
          v-model="searchForm.courseType"
          placeholder="请选择课程方式"
          filterable
          clearable
          @change="getList()"
        >
          <el-option
            v-for="item in courseTypeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
      <div class="r">
        <el-select
          v-model="courseSearchType"
          class="input-select"
          placeholder="请选择状态"
          filterable
          clearable
          @change="clearSearchValue"
        >
          <el-option
            v-for="item in courseSearchList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-input
          v-model="searchForm[courseSearchType]"
          :placeholder="placeholder[courseSearchType]"
          @keyup.enter.native="getList()"
        >
          <el-button
            slot="append"
            type="primary"
            @click="getList()"
          >
            搜索
          </el-button>
        </el-input>
        <el-button
          type="primary"
          @click="create"
        >
          新建课程
        </el-button>
      </div>
    </div>
    <data-table
      :data="tabelData"
      :pagination="true"
      :table-column="tableColumn"
      @changeBypagination="tableHandle"
      @buttonClick="buttonClick"
    />
  </div>
</template>

<script>
import axClient from '@/services';
import dataTable from '@/components/common/dataTable.vue';
import types, {
  courseSearchList, courseStatusList, courseTypeList,
} from '@/config';

export default {
  name: 'Home',
  components: {
    dataTable,
  },
  data() {
    return {
      courseSearchList, // 搜索字段
      courseStatusList,
      courseTypeList,
      courseCategoryList: [],
      tabelData: {},
      courseSearchType: 'courseName',
      placeholder: {
        courseName: '请输入课程名称',
        mainTeacherUserRealName: '请输入主讲老师名称',
      },
      searchForm: {
        pageNum: 1,
        pageSize: 10,
        courseCategoryId: '', // 课程类型
        valid: '',
        courseType: '', // 课程方式
        courseName: '',
        mainTeacherUserRealName: '',
      },
      tableColumn: [
        {
          key: 'courseName',
          label: '课程名称',
          width: '80px',
          dataType: 'text',
        },
        {
          key: 'courseCategoryName',
          label: '课程类型',
          width: '80px',
          dataType: 'text',
        },
        {
          key: 'courseSimpleIntro',
          label: '课程简介',
          dataType: 'text',
          substr: 10,
        },
        {
          key: 'mainTeacherUserRealName',
          label: '主讲老师',
          width: '80px',
          dataType: 'text',
        },
        {
          key: 'rank',
          label: '排序值',
          width: '80px',
          dataType: 'text',
        },
        {
          key: 'coursePrice',
          label: '课程价格',
          width: '90px',
          dataType: 'money',
        },
        {
          key: 'valid',
          label: '课程状态',
          width: '80px',
          dataType: 'component',
          renderProps: { [types.COURSE_CATEGORY_ENABLE]: '上架', [types.COURSE_CATEGORY_DISABLE]: '下架', successKey: types.COURSE_CATEGORY_ENABLE },
          render: () => 'status',
        },
        {
          key: 'courseType',
          label: '课程方式',
          width: '80px',
          dataType: 'function',
          renderProps: '',
          render: (key) => courseTypeList.filter((item) => item.value === key),
        },
        {
          key: 'createTime',
          label: '创建时间',
          width: '100px',
          dataType: 'time',
        },
        {
          key: 'control',
          label: '操作',
          width: '220px',
          dataType: 'component',
          renderProps: [
            {
              text: '下架', renderKey: types.COURSE_ENABLE, renderProp: 'valid', eventIndex: 0, disableKey: null,
            },
            {
              text: '上架', renderKey: types.COURSE_DISABLE, renderProp: 'valid', type: 'success', eventIndex: 0, disableKey: null,
            },
            {
              text: '编辑', renderKey: null, type: 'primary', eventIndex: 1, disableKey: null,
            },
            {
              text: '详情', renderKey: null, type: 'info', eventIndex: 2, disableKey: null,
            },
            {
              text: '删除', renderKey: null, type: 'danger', eventIndex: 3, disableKey: null,
            },
          ],
          render: () => 'buttons',
        },
      ],
    };
  },
  mounted() {
    this.getList();
    this.selectList();
  },
  methods: {
    // 切换下拉 清除选项的值
    clearSearchValue() {
      this.searchForm.courseName = '';
      this.searchForm.mainTeacherUserRealName = '';
    },
    // 获取列表
    async getList(num = 1) {
      this.searchForm.pageNum = num;
      const result = await axClient.course.pageCourse(this.searchForm);
      const { pageNum, pageSize, total } = result;
      this.tabelData = {
        pageNum,
        pageSize,
        total,
        list: result.list,
      };
    },
    // 下拉列表
    async selectList() {
      const all = {
        id: '',
        value: '全部',
      };
      this.courseCategoryList = await axClient.course.listCategoryName();
      this.courseCategoryList = [all, ...this.courseCategoryList];
    },
    // 跳转到详情
    goDetails(item) {
      this.$router.push({ name: 'CourseDetails', params: { courseClassId: item.courseClassId } });
    },
    // table 改变 pagination 时间
    tableHandle(pageNum, pageSize) {
      this.searchForm.pageNum = pageNum;
      this.searchForm.pageSize = pageSize;
      this.getList(pageNum);
    },
    // 删除
    deletedItem(item) {
      this.$confirm('确定删除该课程？', '删除课程', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showClose: false,
        type: 'error',
      }).then(async () => {
        const { id } = item;
        const data = await axClient.course.updateCourseValid(
          {
            id,
            valid: types.COURSE_DELETE,
          },
        );
        if (data) {
          this.$message.success('删除成功');
          this.getList();
        }
      });
    },
    // 下架/上架 课程
    confirmDialog(item) {
      this.$confirm('确定下架/上架该课程？', '下架/上架课程', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showClose: false,
        type: 'error',
      }).then(async() => {
        const { id, valid } = item;
        const data = await axClient.course.updateCourseValid(
          {
            id,
            valid: valid === types.COURSE_ENABLE
              ? types.COURSE_DISABLE : types.COURSE_ENABLE,
          },
        );
        if (data) {
          this.$message.success('上架/下架成功');
          this.getList();
        }
      });
    },
    // table 传递过来的按钮点击
    buttonClick(type, item) {
      switch (type) {
        case 0:
          this.confirmDialog(item);
          break;
        case 1:
          this.create(item);
          break;
        case 2:
          this.goDetails(item);
          break;
        case 3:
          this.deletedItem(item);
          break;
        default:
          break;
      }
    },
    // 新增课程
    create(item) {
      this.$router.push({ name: 'CourseCreate', params: { courseClassId: item.courseClassId } });
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
